<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid" id="droparea" style="position:relative;height:100%;">
    <div class="row" style="overflow: hidden; max-height: 30%;" v-if="loadedProcedure.Url != null && loadedProcedure.Url != ''">
      <img v-bind:alt="$t('no_image')" style="padding:10px;" v-bind:src="loadedProcedure.Url" width="100%" />
    </div>
    <div class="row">
      <div class="col">
        {{procedurename}}
      </div>
    </div>

    <div @click="editAutoSaveCategory(true)" class="row mt-1" v-if="alloweditname != true && hasslideshow == false">
      <div class="col-12 custom-medium-text" style="padding-left: 10px; color: #595959">
        {{name}}
        <!--<button v-show="this.$store.getUserPermissionLevel() > 4 && scheduleid != '-1'" @click="editprocname(true)" type="submit" class="btn pt-0 p-0 pull-right" style="margin-top:8px"><i class="fa fa-edit" style="font-size: 20px; color: #A2A2A2"></i></button>-->
      </div>
    </div>
    <div class="row mt-1" v-if="alloweditname == true && hasslideshow == false">
      <div class="col-12 pr-1">
        <input @focusout="saveprocname" @blur.native="unselectTitle" class="form-control col-12 pull-left" type="text" id="procedurename" name="procedurename" v-bind:placeholder="$t('enter_procedure_name')" v-model="updatename" />
      </div>
      <!--<div class="col-3 px-0">
        <button @click="editprocname(false)" type="submit" class="btn pull-left btn-light mr-1 px-1" style="width:35px"><i class="icon-cross2"></i></button>
        <button @click="saveprocname" type="submit" class="btn skin primary-button pull-left px-1" style="width:35px"><i class="icon-checkmark2"></i></button>
      </div>-->
    </div>
    <div class="row mt-3" v-if="$store.getAuthenticationType() != 'onlyemail' && $store.getAuthenticationType() != 'anonymous' && hasslideshow == false">
      <div class="col-12 p-0 m-0" style="padding-left:20px;" v-show="loadedProcedure.CategoryColour != null">
        <div class="p-2" v-bind:style="{ background: loadedProcedure.CategoryColour, color:textcolor }" style="padding-left:10px;padding-bottom:10px;padding-top:5px;"><span style="font-size:16px; text-transform:uppercase">{{loadedProcedure.ProcedureCategoryName}}</span></div>
      </div>
      <div class="col-12 p-0 m-0" style="padding-left: 20px;" v-show="loadedProcedure.CategoryColour == null">
        <div class="" style="padding-left: 10px; padding-bottom: 0px; padding-top: 0px;"><span style="font-size:16px; text-transform:uppercase">{{loadedProcedure.ProcedureCategoryName}}</span></div>
      </div>
    </div>
    <div v-show="loadedProcedure.EnableStatus == true && hasslideshow == false" class="row mt-3">
      <div class="col-12 custom-form-label" style="padding-left: 10px;">
        {{$t('status')}}
      </div>
    </div>
    <div v-show="loadedProcedure.EnableStatus == true && hasslideshow == false" class="row mt-1">
      <div class="col-12" style="padding-left: 10px;">
        <select class="form-control settingsdrop" v-model="status" @change="changeStatus">
          <!--<option value="0">{{ $t('created') }}</option>-->
          <option value="1">{{ $t('started') }}</option>
          <option value="2">{{ $t('done') }}</option>
          <option value="6">{{ $t('not_done') }}</option>
          <!--<option value="3">{{ $t('verified') }}</option>
          <option value="4">{{ $t('closed') }}</option>-->
        </select>
      </div>
    </div>

    <div v-show="loadedProcedure.EnablePriority == true && hasslideshow == false" class="row mt-3">
      <div class="col-12 custom-form-label" style="padding-left: 10px;">
        {{$t('priority')}}
      </div>
    </div>
    <div v-show="loadedProcedure.EnablePriority == true && hasslideshow == false" class="row mt-1">
      <div class="col-12" style="padding-left: 10px;">
        <select class="form-control prioritydrop" v-model="priority" @change="changePriority">
          <option value="0">{{ $t('low') }}</option>
          <option value="1">{{ $t('medium') }}</option>
          <option value="2">{{ $t('high') }}</option>
        </select>
      </div>
    </div>





    <div class="row mt-3" v-if="hasslideshow == false && description != null && description != ''">
      <div class="col-12 p-0 m-0" style="padding-left: 20px;">
        <div class="" style="padding-left: 10px; padding-bottom: 0px; padding-top: 0px;"><span v-html="getPorcedureDesc(description)" style="font-size: 16px; color: black;"></span></div>
      </div>
    </div>



    <div v-show="hasslideshow == false && (loadedProcedure.EnableDescription == true || (loadedProcedure.IsTask == true && getDescription(worknote) != ''))" class="row mt-3">
      <div class="col-12 custom-form-label" style="padding-left: 10px;">
        {{$t('worknote')}}
      </div>
    </div>

    <div v-show="loadedProcedure.EnableDescription == true && hasslideshow == false" class="row mt-1">
      <div class="col-12" v-show="!worknoteedit">
        <!--<textarea class="form-control" v-model="worknote" @change="textChanged(el)" v-bind:placeholder="$t('worknote')"></textarea>-->
        <div @click="worknoteclick(true)" v-html="worknote"></div>
      </div>
      <div class="col-12" v-show="worknoteedit">
        <mce-editor filefolder="News" v-bind:doinit="false" ref="mce" value="" name="description"></mce-editor>
        <div class="col-lg-12 form-group pt-3 px-0">
          <a style="color:inherit" @click="saveWorkNote" class="btn btn-link skin btn-primary pull-right">{{$t('save')}}</a>          
          <a style="color:inherit" @click="worknoteclick(false)" class="btn skin btn-link pull-right mr-1">{{$t('cancel')}}</a>
        </div>
      </div>
    </div>

    <!--<div v-show="!(loadedProcedure.EnableDescription == true) && getDescription(worknote) != ''" class="row mt-2">
      <div class="col-12">
        <span v-html="getDescription(worknote)"></span>
      </div>
    </div>-->
    <div v-show="loadedProcedure.TempSuccessMessage !== undefined  && loadedProcedure.TempSuccessMessage !== '' && loadedProcedure.TempSuccessMessage !== null" class="row mt-2">
      <div class="col-12">
        <span v-html="loadedProcedure.TempSuccessMessage"></span>
      </div>
    </div>
    <div class="row" v-show="loadedProcedure.TempSuccessMessage === undefined  || loadedProcedure.TempSuccessMessage === '' || loadedProcedure.TempSuccessMessage === null">
      <div class="col">
        <nested-viewproperty @add_pending_chat_message="addPendingChatMessage" v-bind:isshifttask="isshifttask" v-bind:assigned="assigned" @changed="changed" ref="nestedviewproperty" v-bind:date="date" v-bind:scheduleid="scheduleid" @deleteItem="deleteItem" @clickItem="clickItem" @openUrl="openUrl" v-bind:displaydropmessage="true" style="z-index:10000;" />
      </div>
    </div>
    <div class="form-group row m-0 p-0" v-show="loadedProcedure.EnableTimespent == true">
      <div class="container-fluid custom-form-label m-0 p-0">
        <i class="icon-alarm mr-1"></i><span class="mt-3">{{$t('time_spent')}}: <span class="font-weight-semibold">{{hours}}h, {{minutes}}min</span></span>
      </div>
      <form id="timeSpentForm" name="timeSpentForm" class="login-formx form-validate col-12 m-0 p-0" action="index.html" onsubmit="return false">
        <div class="col-lg-12">
          <div class="row mt-1">
            <div class="col-1 px-0">
              <input required v-model="hours" @change="calCulatetime" type="text" id="txthour" v-bind:placeholder="$t('hours')" maxlength="5" name="hour" class="form-control" />
            </div>
            <div class="col-1 form-control" style="border:none;">
              h
            </div>
            <div class="col-1 px-0">
              <input required v-model="minutes" type="text" @change="calCulatetime" id="txtminute" v-bind:placeholder="$t('minutes')" maxlength="2" name="minute" class="form-control" />
            </div>
            <div class="col-9 form-control" style="border:none;">
              m
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="row mobilemargin">
      <div class="col">

      </div>
    </div>
    <LightBox id="lightboxtmp" ref="lightbox"
              :media="media"
              :show-caption="true"
              :show-light-box="false" />

    <modal-default ref="modaleditor" :onsave="saving" v-bind:title="$t('upload')">
      <p v-if="urlerrors.length">
        <ul>
          <li v-for="error in urlerrors" class="validation-invalid-label">{{ error }}</li>
        </ul>
      </p>
      <upload-file-selector2 ref="uploader" @change="urlChange"></upload-file-selector2>
    </modal-default>


  </div>
</template>

<script>


  var media = [
    {
      thumb: '',
      src: '',
      caption: ''
    }
  ]

  var urlerrors = [];
  //var text = "";
  //var filesettings = null;
  var files = [];
  //var internalurl = "";
  var procedurename = "";
  var selectedElement = null;


  import LightBox from 'vue-image-lightbox'
  import NestedViewProperty from "./nested-viewproperty.vue";
  import UploadSelector2 from "../upload/upload-file-selector2.vue";
  import ModalDefault from "../modals/modal-default.vue";
  import InputSlider from "../form-components/input-slider.vue";
  import ProcedurescheduleSettings from "./procedureschedule-settings.vue";
  import vuescroll from 'vuescroll';
  var elements = [];


  export default {
    name: "procedure-workmode",
    display: "Nested (v-model & vuex)",
    order: 16,
    components: {
      NestedViewProperty,
      LightBox,
      UploadSelector2,
      ModalDefault,
      ProcedurescheduleSettings,
      vuescroll
    },
    data() {
      return {
        loadedProcedure: {},
        status: 0,
        description: '',
        worknote: '',
        name: '',
        activeColor: 'red',
        fontSize: 30,
        priority: 0,
        updatename: '',
        alloweditname: false,
        textcolor: '',

        elements,
        //internalurl,
        //filesettings,
        urlerrors,
        procedurename,
        media,
        selectedElement,
        //text,
        hours: 0,
        minutes: 0,
        files,
        worknoteedit: false,
      };
    },
    computed: {
      procedure: {
        get() {
          $("#timeSpentForm").validate({
            rules: {
              hour: {
                required: true,
                number: true
              },
              minute: {
                required: true,
                number: true,
                range: [0, 59]
              },
            }
          });
          return this.$store.state.procedure;
        },
        set(value) {
          //alert("updateprocedure 23");
          this.$store.commit('saveprocedure', value)
        }
      }
    },
    props: {
      hasslideshow: {
        required: false,
        type: Boolean,
        default: false
      },
      scheduleid: {
        required: false,
        type: String,
        default: null
      },
      assigned: {
        required: false,
        type: String,
        default: null
      },
      isshifttask: {
        required: false,
        type: Boolean,
        default: false
      },


    },
    methods: {
      
      isShowWorkNoteEditor() {
        if (this.worknote === null || this.worknote === '') {
          this.worknoteedit = true;
          this.$refs.mce.setValue('');
        }
      },
      saveWorkNote() {
        try {
          var data = {
            schid: this.scheduleid,
            worknote: this.$refs.mce.getValue()
          };
          var url = '/api/Procedure/SaveTaskWorkNote';
          this.$http.post(url, data).then(async response => {
            //vm.$root.$emit('doSearch');
            this.worknote = data.worknote;
            this.worknoteclick(false);            
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      worknoteclick(isedit) {
        this.worknoteedit = isedit;
        if (isedit) {
          var val = this.worknote === null ? "" : this.worknote;
          this.$refs.mce.setValue(val);
        } 
      },
      init() {
        this.$refs.mce.initMCE();
      },
      getPorcedureDesc(description) {
        if (description != null && typeof (description) != 'undefined') {
          description = description.replace(/(?:\r\n|\r|\n)/g, '<br>');
        }
        return description;
      },
      saveprocname() {
        try {
          var data = {
            id: this.scheduleid,
            name: this.updatename
          };
          var url = '/api/Procedure/UpdateProcedureScheduleName';
          this.$http.post(url, data).then(async response => {
            //alert('doSearch12')
            this.name = response.data.name;
            this.updatename = response.data.name;
            this.editprocname(false);
            vm.$root.$emit('doSearch');

          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      editprocname(allow) {
        this.alloweditname = allow;
        this.$forceUpdate();
      },
      unselectTitle() {
        this.editprocname(false);
      },
      editAutoSaveCategory(allow) {
        if (this.$store.getUserPermissionLevel() > 4 && this.scheduleid != '-1') {
          this.editprocname(allow);
        }
      },
      changePriority() {
        //var proc = this.procedure;
        //console.log(this.procedure);
        //proc.Priority = this.priority;
        //this.procedure = proc;
        //this.$emit("changed");
        setPriority(this.procedure.ProcedureScheduleId, this.priority)
      },
      changeStatus() {
        //var proc = this.procedure;
        //proc.Status = this.status;
        //this.procedure = proc;
        //this.$emit("changed");
        setStatus(this.procedure.ProcedureId, this.procedure.Date, this.procedure.ProcedureScheduleId, this.status);
      },
      getTextColor(color) {
        if (color == null || typeof (color) == "undefined")
          return "black"
        else if (ColorUtils.isLight(color)) {
          return "black"
        }
        return "white"
      },
      async setProcedure(val) {
        this.worknoteclick(false);
        this.loadedProcedure = val;
        this.alloweditname = false;
        this.description = val.Description;
        this.worknote = val.ScheduleWorkNote;
        this.isShowWorkNoteEditor();
        if (this.scheduleid < 0 || this.scheduleid === undefined
          || this.scheduleid === "") {

          this.name = val.ProcedureName
          this.updatename = val.ProcedureName
        }
        else {

          this.name = val.ProcedureScheduleName
          this.updatename = val.ProcedureScheduleName
        }

        this.priority = val.Priority;
        this.status = val.Status;
        this.textcolor = this.getTextColor(val.CategoryColour);

      },

      updateProcedureSchedule() {
        try {
          if (this.scheduleid <= 0) return;
          var data = {
            id: this.scheduleid,
            status: this.status,
            priority: this.priority,
            name: this.name,
            description: this.worknote
          };
          //console.log("UpdateProcedureSchedule:" + JSON.stringify(data))
          var url = '/api/Procedure/UpdateProcedureSchedule';
          this.$http.post(url, data).then(async response => {
            //alert('doSearch12')
            vm.$root.$emit('doSearch');
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      descriptionChanged() {
        this.updateProcedureSchedule();
      },
      nameChanged() {
        this.updateProcedureSchedule();
      },
      getDescription(description) {
        //alert(this.loadedProcedure.TempSuccessMessage);
        if (typeof (description) != 'undefined' && description != null && description != '')
          return description.replace(/\n/g, '</br>')
        return "";
      },
      textChanged(el) {
        var proc = this.procedure;
        proc.ScheduleWorkNote = this.worknote;
        this.procedure = proc;
        this.$emit("changed");
      },
      async loadElements(elements) {
        this.$refs.nestedviewproperty.setElements(elements);
      },
      addChatMessage(val, el) {
        this.$emit("add_chat_message", val, el)
      },
      addPendingChatMessage(val, el) {
        this.$emit("add_pending_chat_message", val, el)
      },
      changed() {
        this.$emit("changed")
      },
      saving() {

        if (this.selectedElement.EnableMultiple == false) {

          // there can only be one child, so clear the others
          for (var i = 0; i < this.selectedElement.UserInputs.length; i++) {
            this.selectedElement.UserInputs[i].IsDeleted = true;
          }

          //this.selectedElement.UserInputs = [];



          // Add one single file
          var newUserInput = {
            ElementType: this.selectedElement.ElementType,
            Settings: JSON.parse(JSON.stringify(this.files[0].filesettings)),
            IsAdded: true,
          }

          if (this.files[0].internalurl != null && this.files[0].internalurl != "") {
            newUserInput.Url = this.files[0].internalurl;
          }
          newUserInput.Id = -1;
          newUserInput.ParentId = this.selectedElement.Id;

          newUserInput.Value = this.files[0].text;

          this.selectedElement.UserInputs.push(newUserInput);


        }
        else {
          for (var i = 0; i < this.files.length; i++) {

            // Adding multiple files
            var newUserInput = {
              ElementType: this.selectedElement.ElementType,
              Settings: JSON.parse(JSON.stringify(this.files[i].filesettings)),
              IsAdded: true,
            }

            if (this.files[i].internalurl != null && this.files[i].internalurl != "") {
              newUserInput.Url = this.files[i].internalurl;
            }
            newUserInput.Id = -1;
            newUserInput.ParentId = this.selectedElement.Id;
            newUserInput.Value = this.files[i].text;

            this.selectedElement.UserInputs.push(newUserInput);

          }

          this.selectedElement.changed = true;
        }

        Vue.set(this.selectedElement, "UserInputs", this.selectedElement.UserInputs)

        // Clear values
        this.files = [];
        this.$forceUpdate();
        this.$refs.uploader.reset();
        this.$refs.modaleditor.disableButton();
        this.$refs.modaleditor.close();

      },
      urlValidationError(errors) {
        this.urlerrors = errors;
      },
      urlChange(val, text, settings) {
        this.$refs.modaleditor.enableButton();
        this.files.push({ filesettings: settings, internalurl: val, text: text, Property: {} })
        this.saving();
        this.$refs.modaleditor.close();
        //this.filesettings = settings;
        //this.internalurl = val;
        //this.text = text
      },
      deleteItem(el, elements) {
        if (elements == null || typeof elements == "undefined")
          elements = this.procedure.Elements;
        for (var i = 0; i < elements.length; i++) {
          if (elements[i] == el) {
            elements = elements.splice(i, 1);
            return;
          }
          else {
            this.deleteItem(el, elements[i].Elements);
          }
        }
      },
      openUrl(url, name) {

        var mimetype = this.getMimeType(url);
        this.$refs.lightbox.showThumbs = false;
        this.$refs.lightbox.showFooterCount = false;

        var mediaObjects = [];
        if (mimetype.indexOf('image') != -1) {
          var obj = {
            thumb: url,
            src: url,
            caption: name,
          }
          mediaObjects.push(obj);
          this.media = mediaObjects;
          this.$refs.lightbox.showImage(0);


        } else if (mimetype.indexOf('video') != -1) {
          var obj = {
            thumb: url,
            sources: [
              {
                src: url,
                type: mimetype,
              },
            ],
            type: 'video',
            caption: name,
            width: 800,
            height: 600,
            autoplay: true,
          }
          mediaObjects.push(obj);
          this.media = mediaObjects;
          this.$refs.lightbox.showImage(0);
          lightboxToFront('#lightboxtmp')
        }
        else {
          if (url.match(/api\/upload\/file/i)) {
            var u = window.location.href;
            var baseUrl = u.split(window.location.pathname)[0];
            url = baseUrl + url; // relative path
          }
          //else if (!url.match(/^http?:\/\//i)) {
          //  url = 'https://' + url;
          //}
          window.open(url, '_blank');
        }
      },

      clickItem(element) {

        if (element.Url != null && element.Url != "") {

          var mimetype = this.getMimeType(element.Url);
          if (element.ElementType == 0 && (mimetype.indexOf('image') != -1 || mimetype.indexOf('video') != -1)) {

            var url = element.Url;
            var index = 0;

            var allElements = this.getFlat(this.loadedProcedure.Elements);

            this.media = this.getMedia(allElements);
            for (var i = 0; i < this.media.length; i++) {
              if (this.media[i] != null && this.media[i].src == url || this.media[i].thumb == url) {
                index = i;
              }
            }
            this.$refs.lightbox.showThumbs = true;
            this.$refs.lightbox.showFooterCount = true;
            this.$refs.lightbox.showImage(index)
            lightboxToFront('#lightboxtmp');
          }
          else {
            var url = element.Url;
            if (url.match(/api\/upload\/file/i)) {
              var u = window.location.href;
              var baseUrl = u.split(window.location.pathname)[0];
              url = baseUrl + url; // relative path
            }
            //else if (!url.match(/^http?:\/\//i)) {
            //  url = 'https://' + url;
            //}
            window.open(url, '_blank');
          }
        }
        else if (element.ElementType == 5 && element.Url == null) {

          this.selectedElement = element;
          //this.internalurl = null;
          //this.text = null;
          //this.filesettings = null;
          this.files = [];

          this.$refs.uploader.reset();


          if (element.Settings != null && element.Settings.Property != null && element.Settings.Property.ForceRecent == "true") {
            this.$refs.uploader.forceRecency(true);
          }
          else {
            this.$refs.uploader.forceRecency(false);
          }

          if (element.Settings != null && element.Settings.Property != null && element.Settings.Property.ForceCamera == "true") {
            this.$refs.uploader.setCapture("camera");
            this.$refs.uploader.setAccept("image/*");
          }
          else {
            this.$refs.uploader.setCapture("");
          }

          this.$refs.modaleditor.disableButton();
          this.$refs.modaleditor.open();

        }

      },
      getFlat(elements) {
        var arr = [];
        for (var i = 0; i < elements.length; i++) {
          arr.push(elements[i]);
          var children = this.getFlat(elements[i].Elements);
          for (var k = 0; k < children.length; k++) {
            arr.push(children[k]);
          }
        }
        return arr;
      },
      getMedia(elements) {

        var mediaObjects = [];
        for (var i = 0; i < elements.length; i++) {
          if (elements[i].ElementType == 0) {

            if (elements[i].Url != null && elements[i].Url != "") {
              var mimetype = this.getMimeType(elements[i].Url);
              if (mimetype.indexOf('image') != -1) {
                //alert('image');
                var obj = {
                  thumb: elements[i].Url,
                  src: elements[i].Url,
                  caption: elements[i].Text,
                }
                mediaObjects.push(obj);
              } else if (mimetype.indexOf('video') != -1) {
                //alert('video');
                var obj = {
                  thumb: elements[i].Url,
                  sources: [
                    {
                      src: elements[i].Url,
                      type: mimetype,
                    },
                  ],
                  type: 'video',
                  caption: elements[i].Text,
                  width: 800,
                  height: 600,
                  autoplay: true,
                }
                mediaObjects.push(obj);
              }
            }
          }
        }
        return mediaObjects;
      },

      getMimeType(url) {
        var mimetype = '', hash;
        var hashes = url.slice(url.indexOf('?') + 1).split('&');
        if (url.indexOf('mimetype' > -1)) {
          for (var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            if ("mimetype" == hash[0]) {
              mimetype = hash[1];
            }
          }
        }
        return mimetype;
      },

      getParent(element) {
        var elements = this.getFlat(this.loadedProcedure.Elements);
        for (var i = 0; i < elements.length; i++) {
          for (var k = 0; k < elements[i].Elements.length; k++) {
            if (elements[i].Elements[k] == element)
              return elements[i];
          }
        }
        return null;
      },
      setDone() {
        this.$emit('done');
      },
      assign() {
        this.$emit('assign');
      },
      handleRefresh(val) {

        //Vue.set(this, "elements", []); // Clear all first
        //this.$forceUpdate();

        lightboxToOrigin('#lightboxtmp')

        this.$refs.lightbox.closeLightBox();

        /*
        Vue.set(this, "elements", val.Elements);
        this.$forceUpdate();
        this.$refs.nestedviewproperty.setElements(val.Elements);
        this.$refs.nestedviewproperty.reload();
        */

        var time = 0;
        if (this.loadedProcedure.TimeSpentTicks != null) {
          time = parseFloat(this.loadedProcedure.TimeSpentTicks) / 36000000000;
        }
        //this.$forceUpdate();
        this.setTimeControlValue(time);
      },
      setTimeControlValue(timeEst) {
        this.minutes = 0;
        this.hours = parseInt(timeEst);
        var partOfHour = timeEst % 1;
        if (partOfHour > 0)
          this.minutes = parseInt((partOfHour * 60));
      },
      calCulatetime() {
        if (/^\d*$/.test(this.hours) === false) {
          this.hours = 0;
        }
        if (/^\d*$/.test(this.minutes) === false) {
          this.minutes = 0;
        }
        if (this.minutes > 59) {
          this.minutes = 0;
        }
        var h = parseInt(this.hours) + parseInt(this.minutes) / 60;
        if (h > 0) {
          this.updateTimeSpent(h.toFixed(2));
        }
      },
      //changeTimeSpent(val) {
      //  //this.procedure.EstimatedTimeTimeTicks = val * 36000000000;
      //  var hours = parseInt(val);
      //  var partOfHour = val % 1;
      //  var label = hours + "h";
      //  if (partOfHour > 0)
      //    label += ", " + (partOfHour * 60) + "min";
      //  this.$refs.timeSpentSlider.label = label;
      //  this.updateTimeSpent(val);
      //},
      updateTimeSpent(val) {
        try {
          var url = '/api/Procedure/UpdateTimeSpent?procedureScheduleId=' + this.scheduleid + '&timespent=' + val;
          this.$http.get(url).then(async response => {
            //alert('doSearch11')
            vm.$root.$emit('doSearch');
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      }
    },
    created() {
      this.$root.$on('procedure_refresh', this.handleRefresh);
      this.$root.$on('procedure_reset', this.handleRefresh);
    },
    mounted() {
      this.init();

    },
  };
</script>

<style scoped>
  .mobilemargin {
    margin-bottom: 250px;
  }

  @media (max-width: 768px) {
  }
</style>



// WEBPACK FOOTER //
// src/components/procedure/procedure-workmode.vue